"use client";

import { useEffect } from "react";
import { lock_body_scroll } from "@core/helpers/client/scroll-lock";

export { lock_body_scroll } from "@core/helpers/client/scroll-lock";

// Locks the page scroll while `locked` is true (popups, modals, sheets, drawers of every site). Nesting-safe and
// restores the value that was there before (see `lock_body_scroll`), and unlocks on unmount.
// options: { target, mode, property, value, class_name } as in `lock_body_scroll`. Pass `target` as a selector
// string or a ref: an inline element/function changes every render and would re-lock every render.
export default function useBodyScrollLock(locked, options = {}) {
	const { target, mode, property, value, class_name } = options;

	useEffect(() => {
		if (!locked) return;
		return lock_body_scroll({ target, mode, property, value, class_name });
	}, [locked, target, mode, property, value, class_name]);
}
